export const DATA_FILTER_STORE_COMMON_ID = 'data-filter';
